"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = __importDefault(require("axios"));
var config_1 = __importDefault(require("../../config"));
var axiosConfig = {
    baseURL: config_1.default.apiBaseUrlV2,
    headers: {
        'Content-Type': 'application/json;charset=UTF-8',
        Accept: 'application/json'
    },
    xsrfCookieName: process.env.NODE_ENV.toUpperCase() + "-CSRF-TOKEN",
    xsrfHeaderName: 'X-CSRF-Token',
    withCredentials: true
};
var instance = axios_1.default.create(axiosConfig);
instance.interceptors.response.use(function (response) {
    return response;
}, function (error) {
    if (error && error.response && error.response.status === 401 && window && window.location) {
        var returnTo = window.location.href;
        window.location.href = config_1.default.applicationBaseUrl + "/users/sign_in?return_to=" + returnTo;
        return;
    }
    return Promise.reject(error);
});
exports.default = instance;
exports.BASE_URL_V2 = config_1.default.apiBaseUrlV2;
//# sourceMappingURL=api_base.js.map